import axios from "axios";
import { BASE_URL } from "../Config";
import { decrypt } from "./crypto";
import {decryptData} from "./index"

const setAxiosDefaults = () => {
  axios.defaults.baseURL = BASE_URL;
  // axios.defaults.withCredentials = true;
  axios.interceptors.request.use((req) => {
    
    const urlParts = req.url.split("/");
      const lastApiCall = urlParts[urlParts.length - 1];
      // console.log("lastApiCall",lastApiCall);
      // if (lastApiCall !== "updateLeadUpsell2") {
        sessionStorage.setItem("lastApiCall", lastApiCall);
      // }
      if (!navigator.onLine) {
        throw new axios.Cancel("API call cancelled due to connectivity issue");
      }
      return req;
    },
    async (err) => {
      return Promise.reject(err);
    }
  );

  axios.interceptors.response.use(
    (res) => {
      res.response = decryptData(res.data);
      // console.log(res.response);
      return res;
    },
    async (err) => {
      console.error(err);
      const status = err.response ? err.response.status : null;
      if (status === 401) {
        // return Promise.reject("Unauthorised");
        const currentURL = window.location.href;
        const lastSlashIndex = currentURL.lastIndexOf("/");
        const resultURL = currentURL.slice(0, lastSlashIndex);
        window.location.replace(resultURL + "/login");
      }
      return Promise.reject(err);
    }
  );
};

export default setAxiosDefaults;
